import React from "react";
import FormDropdown from "../../components/Widget/FormDropdownMapel.js";

const DropdownView = ({
	handleChange,
	stateName,
	label,
	placeholder,
	value,
	disabled,
	items
}) => (
	<div className="form-group row">
		<div className="col-md-12">
			<FormDropdown
				name={stateName}
				onChange={handleChange}
				items={items}
				value={value}
				disabled={disabled}
			/>
		</div>
	</div>
);

export default DropdownView;



// WEBPACK FOOTER //
// ./src/views/Mapel/DropdownView.js